import React from 'react';
import Layout from "../components/Layout";
import Hero from "../components/Hero";
import withTrans from '../i18n/withTranslation';


const ScissorsPage = ({ data, t }) => {

  const getContent = (translation) => {
    return { __html: `${t(translation)}` }
  }

  return (
    <>
      <Layout
        title={t('site.pages.ScissorsPage.meta.title')}
        description={t('site.pages.ScissorsPage.meta.description')}
        img={data.header.publicURL}
      >
        <Hero
          isDark={true}
          title={t('site.pages.ScissorsPage.title')}
          subtitle={t('site.pages.ScissorsPage.subtitle')}
          alt={t('site.pages.ScissorsPage.headerAlt')}
          img={data.header.publicURL}
        />

        <div className="container my-5">
          <div dangerouslySetInnerHTML={getContent('site.pages.ScissorsPage.content')}></div>
          <div className="my-5">
            <ul>
              {t('site.pages.ScissorsPage.list').map((el, index) =>
                <li key={index} className="my-2">{el}</li>)}
            </ul>
          </div>
        </div>
      </Layout>
    </>
  )
}

export const query = graphql`
  query ScissorsPage {
    header: file(relativePath: {eq: "hero-scissors.jpg"}) {
      publicURL
    }
  }
`;

export default withTrans(ScissorsPage);